module.exports = __webpack_public_path__ + "img/fa-solid-900.18df003.svg";